<template>
  <div class="row clearfix">
    <!-- <div class="col-lg-6 col-md-12"> -->
    <!-- <ul class="breadcrumb pl-0 pb-0 " style="background: transparent;"> -->
    <!-- <li class="breadcrumb-item"><router-link to="/developer/app/action/inputs">Inputs</router-link></li> -->
    <!-- <li class="breadcrumb-item">Line Items</li> -->
    <!-- <li class="breadcrumb-item active">Normal Tables</li> -->
    <!-- </ul> -->

    <!-- </div>  -->
    <div class="col-lg-12 col-md-12 col-sm-12">
      <router-view v-bind:typeData="typeOfBtn" />
    </div>
    <div class="col-lg-12 col-md-12 col-sm-12">
      <div class="body">
        <div class="list-group">
          <!-- <div :class=" { 'divPreviewBorder' :this.groupList.key != null && this.groupList.key != '' && this.groupList.label != null && this.groupList.label != ''}" > -->

          <!-- <h4 class="list-group-item-heading">{{ this.groupList.key }} - {{ this.groupList.label }}</h4>
                            <p class="list-group-item-text" v-for="(list, index) in listlist" :key="index">
                                
                                라벨 : {{list.label }} 
                                키 : {{list.key }} 
                            </p> -->

          <!-- </div> -->
        </div>
      </div>

      <!-- <div>{{  this.groupList }} <br> {{this.listlist }} </div> -->
    </div>
  </div>
  <!-- #END# Input -->
</template>

<script>
import eventbus from "@/store/modules/devEventBus";

export default {
  props: ["typeData"],
  methods: {
    changeActionType(num) {
      if (num == 1) {
        this.forSearch = true;
      } else {
        this.forSearch = false;
      }
    },
  },

  data() {
    return {
      types: "",
      forSearch: false,

      listlist: [],
      groupList: { key: "", label: "" },

      typeOfBtn: "inputlineItem",
    };
  },
  mounted() {},
  created() {
    // this.listlist =  this.$store.state.devStore.lineItem

    console.log(this.typeData);
    console.log(this.$store.state.devStore.apiSchema);

    if (this.$store.state.devStore.apiSchema != null) {
      this.groupList.key = this.$store.state.devStore.apiSchema.keys.replace(
        /"/gi,
        ""
      );
      this.groupList.label = this.$store.state.devStore.apiSchema.label.replace(
        /"/gi,
        ""
      );
      console.log(
        "what about me?",
        this.$store.state.devStore.apiSchema.label.replace(/"/gi, ""),
        this.groupList
      );

      this.$store.state.devStore.lineGroup.keys = this.groupList.key;
      this.$store.state.devStore.lineGroup.label = this.groupList.label;

      console.log("체크: ", this.$store.state.devStore.lineGroup);

      this.listlist = JSON.parse(this.$store.state.devStore.apiSchema.form);
    }

    eventbus.$on("listlist", (res) => {
      this.listlist.push(res);

      this.$store.state.devStore.lineItem = this.listlist;

      console.log(this.listlist);

      eventbus.$off("listlist");
    });

    eventbus.$on("grouplist", (res) => {
      console.log(res.get("key"));
      this.groupList.key = res.get("key");
      this.groupList.label = res.get("label");

      this.$store.state.devStore.lineGroup.keys = this.groupList.key;
      this.$store.state.devStore.lineGroup.label = this.groupList.label;

      console.log("체크: ", this.$store.state.devStore.lineGroup);
      console.log(this.groupList);
      console.log(this.$store.state.devStore.lineGroup);
    });

    eventbus.$emit("fieldNum", 2);
  },
  beforeDestroy() {
    eventbus.$off("listlist");
    eventbus.$off("menuSetted");
    console.log("삭제 함 ");
    this.$store.state.devStore.lineGroup = { key: "", label: "" };
    this.$store.state.devStore.lineItem = [];
    this.$store.state.devStore.reMenu = 0;
  },
};
</script>
